import { render, staticRenderFns } from "./ShareBadgeModal.vue?vue&type=template&id=245ad67c&scoped=true&"
import script from "./ShareBadgeModal.vue?vue&type=script&lang=js&"
export * from "./ShareBadgeModal.vue?vue&type=script&lang=js&"
import style0 from "./ShareBadgeModal.vue?vue&type=style&index=0&id=245ad67c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245ad67c",
  null
  
)

export default component.exports